import { Component, OnInit } from '@angular/core';
import { context } from '../contexts/context';
import { CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { TagXitiService } from '../app/services/tagxiti.service';
import { Router, NavigationEnd, Event } from '@angular/router';
import { CnafContacterMaCafService } from './services/contactermacaf.service';
import { setTheme } from 'ngx-bootstrap/utils';

// Déclaration du pageReady
declare let pageReady: any;
declare let afficheChatbot: Function;
declare let cacheChatbot: Function;
declare let pageUniqueName: string;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  title = 'ContacterMaCafAppli';

  constructor(private readonly tagXitiService: TagXitiService,
    private readonly cnafAtTagService: CnafAtTagService,
    private readonly cnafContacterMaCafService: CnafContacterMaCafService,
    private readonly router: Router) {
    // Force bootstrap 3 depuis la migration en Angular 15
    setTheme('bs3');
    if (context.type === 'web') {
      this.title = `${this.title} Web`;
    } else if (context.type === 'mobile') {
      this.title = `${this.title} Mobile`;
    }
    this.cnafContacterMaCafService.tagXitiService = this.tagXitiService;
  }

  ngOnInit(): void {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd && event.url === '/') {
        const tagObj = this.tagXitiService.getAtTagObject('contactermacaf', context.type, '', '', '');
        this.cnafAtTagService.pageSend(tagObj);
      }
    });
    if (typeof afficheChatbot === 'function' && typeof cacheChatbot === 'function') {
      if (pageUniqueName === 'fr.caf.page.Caffr.MonCompte.ContacterMaCaf') {
        afficheChatbot();
      } else {
        cacheChatbot();
      }
    }
  }
}
